import React from 'react'
import classNames from 'classnames'
import { HtmlContent } from 'utils'

import styles from './styles/image_with_text_component.module.scss'

const ImageWithTextComponent = ({title, text, image, text_position}) => {

  const sectionClassNames = classNames({
    [styles.image_with_text_component]: true,
    [styles[`image_with_text_component--${text_position}`]]: true
  })
  return (
    <section className={sectionClassNames}>
      <div className={styles.image_with_text_component__text_wrapper}>
        <h2 className={styles.image_with_text_component__title}>
          {title}
        </h2>
        <HtmlContent content={text} className={styles.image_with_text_component__text} />
      </div>
      <div className={styles.image_with_text_component__img_wrapper}>
        <img loading="lazy"
          className={styles.image_with_text_component__img}
          src={image} 
          alt=''
        />
      </div>
    </section>
  )
}

export default ImageWithTextComponent